export const columnDefinition = [
    { field: "name", headerName: "Бригады", minWidth: 170 },
    {
        field: "n",
        headerName: "N",
        width: 74,
        type: "number",
        sortable: false,
        align: "center",
        headerAlign: "center",
        description: "Количество нарушений",
    },
    {
        field: "w",
        headerName: "Wcp",
        width: 74,
        type: "number",
        sortable: false,
        align: "center",
        headerAlign: "center",
        description: "Тяжесть нарушений",
    },
    {
        field: "t",
        headerName: "Tcp",
        width: 74,
        type: "number",
        sortable: false,
        align: "center",
        headerAlign: "center",
        description: "Время устранения",
    },
    {
        field: "r",
        headerName: "Rcp",
        width: 74,
        type: "number",
        sortable: false,
        align: "center",
        headerAlign: "center",
        description: "Повтор нарушений",
    },
    {
        field: "NPT",
        headerName: "NPT",
        width: 74,
        type: "number",
        sortable: false,
        align: "center",
        headerAlign: "center",
        description: "Непроизводительное время",
      },      
    {
        field: "KPI",
        headerName: "КПЭ",
        headerAlign: "center",
        width: 180,
        renderCell: (cellValues) => {
            if (cellValues.value < 26) {
                return (
                    <div
                        style={{
                            color: "#B82C00",
                            fontSize: 15,
                            width: "100%",
                            textAlign: "center",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
            <span
                style={{
                    lineHeight: 1.5,
                }}
            >
              {"Неэффективные"}
            </span>
                        <hr
                            color="#B82C00"
                            style={{
                                margin: "0 auto",
                                width: "90%",
                            }}
                        />
                        <span
                            style={{
                                lineHeight: 1.5,
                            }}
                        >
              {cellValues.value}
                            {" %"}
            </span>
                    </div>
                );
            }
            if (cellValues.value < 51) {
                return (
                    <div
                        style={{
                            color: "#B88F00",
                            fontSize: 15,
                            width: "100%",
                            textAlign: "center",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
            <span
                style={{
                    lineHeight: 1.5,
                }}
            >
              {"Низкоэффективные"}
            </span>
                        <hr
                            color="#B88F00"
                            style={{
                                margin: "0 auto",
                                width: "90%",
                            }}
                        />
                        <span
                            style={{
                                lineHeight: 1.5,
                            }}
                        >
              {cellValues.value}
                            {" %"}
            </span>
                    </div>
                );
            }
            if (cellValues.value < 76) {
                return (
                    <div
                        style={{
                            color: "#6CB53F",
                            fontSize: 15,
                            width: "100%",
                            textAlign: "center",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
            <span
                style={{
                    lineHeight: 1.5,
                }}
            >
              {"Эффективные"}
            </span>
                        <hr
                            color="#6CB53F"
                            style={{
                                margin: "0 auto",
                                width: "90%",
                            }}
                        />
                        <span
                            style={{
                                lineHeight: 1.5,
                            }}
                        >
              {cellValues.value}
                            {" %"}
            </span>
                    </div>
                );
            } else {
                return (
                    <div
                        style={{
                            color: "#04AF00",
                            fontSize: 15,
                            width: "100%",
                            textAlign: "center",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
            <span
                style={{
                    lineHeight: 1.5,
                }}
            >
              {"Высокоэффективные"}
            </span>
                        <hr
                            color="#04AF00"
                            style={{
                                margin: "0 auto",
                                width: "90%",
                            }}
                        />
                        <span
                            style={{
                                lineHeight: 1.5,
                            }}
                        >
              {cellValues.value}
                            {" %"}
            </span>
                    </div>
                );
            }
        },
    },
];